import { COLORS } from 'styles/globals';
import { ThemeConfigType } from './theme';

export const darkThemeColors = {
  gray01: COLORS.gray12,
  gray02: COLORS.gray12,
  gray03: COLORS.gray12,
  gray12: COLORS.gray12,
  gray13: COLORS.gray01,
  gray07: COLORS.gray01,

  brand01: COLORS.gray01,
  brand02: COLORS.gray01,
  brand02Hover: COLORS.gray01,
  brand03: COLORS.gray01,
  brand04: COLORS.brand04,
  brand05: COLORS.brand05,
  brand06: COLORS.brand06,
  brand07: COLORS.gray01,
  brand08: COLORS.gray01,

  brand02Light2: COLORS.gray01,
  brand02Light3: COLORS.gray12,

  brand02Light: COLORS.gray01,
  brand04Light: COLORS.brand04Light,
  brand05Light: COLORS.brand05Light,
  brand06Light: COLORS.brand06Light,
  brand07Light: COLORS.brand07Light,

  grayInactive: COLORS.gray01,

  errors: COLORS.errors,
  errorsLight: COLORS.errorsLight,
  warning: COLORS.warning,
  breadcumpColor: COLORS.gray03,
  buttonHover: COLORS.gray01,

  textColor01: COLORS.gray01,
  textColor02: COLORS.gray01,
  textColor03: COLORS.gray12,
  textColor04: COLORS.gray12,
  textColor05: COLORS.gray12,
  textColor06: COLORS.gray01,
  textColor07: COLORS.gray01,
  textColor08: COLORS.gray01,
  textColor09: COLORS.gray01,
  textColor10: COLORS.gray01,
  textColor11: COLORS.gray01,
  textColor12: COLORS.gray12,
  textColor13: COLORS.gray01,

  button01: COLORS.gray01,
  button02: COLORS.gray01,

  switchColor01: COLORS.gray01,
  switchColor02: COLORS.gray12,
  switchColor03: COLORS.gray12,
  switchColor04: COLORS.gray12,

  boxShadow: 'transparent',

  transparent: COLORS.transparent,

  placeholder: COLORS.placeholder,
  rowSelectBackground: COLORS.gray07,
  checkedCheckboxBackground: COLORS.black,

  iconColor01: COLORS.gray01,
  iconColor02: COLORS.gray12,
  iconColor03: COLORS.gray01,
  iconColor04: COLORS.gray01,
  iconColor05: COLORS.gray01,
  iconColor06: COLORS.black,
  iconColor07: COLORS.gray01,
  iconColor08: COLORS.gray01,
  iconColor09: COLORS.gray01,
  iconColor10: COLORS.gray12,

  tableHeaderColor: COLORS.gray01,

  disabledText: COLORS.gray01,
  disabledBorder: COLORS.gray01,
  disabledBackground: COLORS.gray12,
  disabledBgForSelect: COLORS.brand08,

  selectOptionColor: COLORS.selectOptionColor,

  darkModeBorder: COLORS.gray01,
  portalBackground: COLORS.gray12,
  componentsBackground: COLORS.gray12,

  border: COLORS.gray01,
  border2: COLORS.gray01,
  border3: COLORS.gray01,
  border4: COLORS.gray01,
  border5: COLORS.gray01,
  customBorder: COLORS.gray01,

  alert01: COLORS.gray12,
  alert02: COLORS.gray12,
  alert03: COLORS.gray12,
  alert04: COLORS.gray12,

  alertBorder01: COLORS.gray01,
  alertBorder02: COLORS.gray01,
  alertBorder03: COLORS.gray01,
  alertBorder04: COLORS.gray01,

  alertIcon01: COLORS.gray01,
  alertIcon02: COLORS.gray01,
  alertIcon03: COLORS.gray01,
  alertIcon04: COLORS.gray01,

  tablePaginationActiveColor: COLORS.gray01,

  tag01: COLORS.gray12,
  tag02: COLORS.gray01,
  tag03: COLORS.gray01,

  tagTextColor0: COLORS.gray12,

  tagBackground01: COLORS.gray01,
  tagBackground02: COLORS.gray12,
  tagBackground03: COLORS.gray12,
  tagBackground04: COLORS.gray12,
  tagBackground05: COLORS.gray01,

  tagBorder01: COLORS.gray01,
  tagBorder02: COLORS.gray01,
  tagBorder03: COLORS.gray01,
  tagBorder04: COLORS.gray01,

  yellow: COLORS.yellow,
  black: COLORS.black,
  blackBg: COLORS.gray01,
  white: COLORS.white,

  rowGreen: COLORS.gray01,
  rowRed: COLORS.gray01,

  scroll: COLORS.black,
  solitude: COLORS.gray01,
  statusYellow: COLORS.gray01,
  statusBrown: COLORS.gray01,
  statusGreen: COLORS.gray01,
  statusBlue: COLORS.gray01,
  statusViolet: COLORS.gray01,
  statusRed: COLORS.gray01,
  statusGray: COLORS.gray01,
  statusDarkBlue: COLORS.gray01,
  statusDarkGreen: COLORS.gray01,

  borderColor: COLORS.gray01,

  statusSupportedBg: COLORS.black,

  statusRealizedColor: COLORS.gray01,
  statusUnsupportedColor: COLORS.gray01,

  dropdownFieldBackground: COLORS.grayDark,
  tableHoverBackground: COLORS.gray12,
  timePickerCellBg: COLORS.brand02,
  timePickerCellText: COLORS.textColor03,
  linkColor: COLORS.gray01,
  headerBgColor: COLORS.black,
  plannedDocsBg: COLORS.yellow,
  closeBtnBg: COLORS.transparent,
  scrollToTopBtnBg: COLORS.black,
  projectTagBorder: COLORS.white,
  scrollShadowBg: COLORS.scrollShadowBgWhite,
  deleteButtonColor: COLORS.gray12,
  deleteButtonBg: COLORS.gray01,
};

export const darkThemeConfig: ThemeConfigType = {
  mobile: {
    components: {
      Button: {
        colorPrimaryActive: '',
        colorPrimaryHover: '',
        colorText: '',
        colorTextLightSolid: '',
        colorBgTextHover: '',
      },
      Input: {
        colorTextDisabled: COLORS.gray12Light,
      },
    },
  },
};
